// extracted by mini-css-extract-plugin
module.exports = {"titleSection":"InputPanel_titleSection_rrL_I","noOutputData":"InputPanel_noOutputData_1R9vZ","notConnected":"InputPanel_notConnected_2M0Uw","title":"InputPanel_title_3AON9"};